export default "__VITE_ASSET__CAdWYyAb__"